export default {
  state: {
    /**
     *  学生 申请表
     * curStep 当前 timeline
     * step1 -- 申请说明 step2 -- 基础信息 step3 -- 教育经历 step4 -- 能力及经验 step5 -- 上传材料 step6 -- 预览及提交
     * timeLineData ---- 左侧 时间轴tab
     * formDataStatus ----- 全部表单数据 状态
     */
    volunteerData: {
      curStep: 1,
      timeLineData: null,
      formData: null,
      submitData: null
    }
  },
  getters: {
    /************ 学生申请 *************/
    /**
     * @description 获取申请表 当前step
     * @param {*} state
     */
    getVolunteerCurStep: state => {
      return state.volunteerData.curStep;
    },
    /**
     * @description 获取申请表 数据
     * @param {*} state
     */
    getVolunteerFormData: state => {
      return state.volunteerData.formData;
    },
    /**
     *  返回 未完成 的表单数据
     * @param {*} state
     */
    getVolunteerReviewData: state => {
      let result = [];
      state.volunteerData.formData.map((item, index) => {
        if (item.error) {
          let temp = JSON.parse(JSON.stringify(item));
          temp.data = [];
          item.data.map(item_sec => {
            let temp_sec = JSON.parse(JSON.stringify(item_sec));
            temp_sec.msgArr = [];
            item_sec.msgArr.map(item_thr => {
              if (item_thr.error) {
                let temp_thr = JSON.parse(JSON.stringify(item_thr));
                temp_sec.msgArr.push(temp_thr);
              }
            });
            if (temp_sec.msgArr.length !== 0) temp.data.push(temp_sec);
          });
          if (index !== state.volunteerData.formData.length - 1) result.push(temp);
        }
      });
      return result;
    }
  },
  mutations: {
    /**
     * 设置 学生申请 timeline step
     * @param {*} state vuex state
     * @param {*} steps
     */
    setVolunteerTimeLine: (state, steps) => {
      state.volunteerData.curStep = steps;
    },
    /**
     * 设置 学生申请表 formData submitData 数据
     * @param {*} state
     * @param {*} formData 表单状态
     * @param {*} submitData 提交数据
     */
    setVolunteerFormData: (state, volunteerData) => {
      state.volunteerData.formData = volunteerData.formData;
      state.volunteerData.submitData = volunteerData.submitData;
    },
    /**
     * 修改申请表 状态 数据 success wrong
     * @param {*} state
     * @param {*} stepStatus 时间轴状态
     * stepStatus :{index: 下标 必填 其余字段 }
     */
    changeVolunteerFormDataStatus: (state, stepStatus) => {
      for (const key in stepStatus) {
        if (key !== 'index') {
          const item = stepStatus[key];
          state.volunteerData.formData[stepStatus.index][key] = item;
        }
      }
    },
    /**
     * @description 修改 提交数据表单
     * @function
     * @param {*}
     * @return {*}
     */
    changeVolunteerSubmitForm: (state, stepData) => {
      for (const key in stepData) {
        const item = stepData[key];
        state.volunteerData.submitData[key] = item;
      }
    }
  },
  actions: {
    /**
     * @description 跳转 学生申请 timeline step
     * @function
     * @param {*} steps
     */
    setVolunteerTimeLine: ({ commit }, steps) => {
      commit('setVolunteerTimeLine', steps);
    },

    // 修改 学生申请 timelINE 状态数据
    changeVolunteerFormDataStatus: ({ commit }, stepStatus) => {
      commit('changeVolunteerFormDataStatus', stepStatus);
    },
    // 设置 学生申请 表单数据
    setVolunteerFormData: ({ commit }, formData) => {
      commit('setVolunteerFormData', formData);
    },
    // 修改 submitData 表单数据
    changeVolunteerSubmitForm: ({ commit }, formData) => {
      commit('changeVolunteerSubmitForm', formData);
    }
  }
};
